import styled from '@emotion/styled'
import Bike from 'assets/icons/biker.svg'
import Run from 'assets/icons/runner.svg'
import Swim from 'assets/icons/swimming.svg'
import Walk from 'assets/icons/walk.svg'

export const SwimIcon = styled(Swim)``
export const RunIcon = styled(Run)``
export const BikeIcon = styled(Bike)``
export const WalkIcon = styled(Walk)`
  transform: scale(0.83);
`
